export default __webpack_public_path__ + "img/27.cdad17.png";